import React from 'react';

const Domains: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-primary text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">Domaines d'intervention</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Nos actions pour le bien-être de la femme et de l'enfant
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto mb-16">
            <p className="text-lg mb-8 text-center">
              MoreLove intervient dans plusieurs domaines clés pour soutenir les femmes et les enfants,
              en accord avec notre mission de partager l'amour de Jésus-Christ à travers l'évangélisation
              et les œuvres sociales.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
            {/* Domain 1 */}
            <div className="card">
              <h2 className="text-2xl font-bold mb-4 text-primary">L'évangélisation</h2>
              <p className="mb-4">
                L'évangélisation de nos populations cibles (les femmes et les enfants) est au cœur de notre mission.
                Nous partageons l'amour de Christ et les valeurs chrétiennes à travers diverses activités :
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Rencontres d'évangélisation</li>
                <li>Études bibliques adaptées</li>
                <li>Programmes spirituels pour enfants</li>
                <li>Mentorat spirituel pour femmes</li>
              </ul>
            </div>

            {/* Domain 2 */}
            <div className="card">
              <h2 className="text-2xl font-bold mb-4 text-primary">L'édification mutuelle</h2>
              <p className="mb-4">
                L'édification mutuelle des membres à travers différentes activités permet de renforcer
                notre communauté et d'approfondir notre foi :
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Retraites spirituelles</li>
                <li>Conférences thématiques</li>
                <li>Groupes de prière et de partage</li>
                <li>Formations bibliques</li>
              </ul>
            </div>

            {/* Domain 3 */}
            <div className="card">
              <h2 className="text-2xl font-bold mb-4 text-primary">La lutte contre la pauvreté</h2>
              <p className="mb-4">
                La lutte contre les disparités sociales notamment la pauvreté est un axe majeur
                de notre intervention :
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Distribution de nourriture et de vêtements</li>
                <li>Aide au logement</li>
                <li>Bourses d'études pour enfants défavorisés</li>
                <li>Programmes d'alphabétisation</li>
              </ul>
            </div>

            {/* Domain 4 */}
            <div className="card">
              <h2 className="text-2xl font-bold mb-4 text-primary">Le soutien social</h2>
              <p className="mb-4">
                Le soutien des membres dans leurs activités sociales renforce notre impact
                communautaire :
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Accompagnement des familles en difficulté</li>
                <li>Soutien aux mères célibataires</li>
                <li>Programmes pour enfants orphelins</li>
                <li>Visites aux personnes isolées</li>
              </ul>
            </div>

            {/* Domain 5 */}
            <div className="card">
              <h2 className="text-2xl font-bold mb-4 text-primary">Les activités génératrices de revenus</h2>
              <p className="mb-4">
                Le soutien à la création des activités génératrices de revenus permet d'autonomiser
                les femmes et d'améliorer durablement leur situation :
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Formations professionnelles</li>
                <li>Microcrédits pour entrepreneures</li>
                <li>Accompagnement de projets</li>
                <li>Ateliers d'artisanat et de commerce</li>
              </ul>
            </div>

            {/* Domain 6 */}
            <div className="card">
              <h2 className="text-2xl font-bold mb-4 text-primary">L'assistance et les dons</h2>
              <p className="mb-4">
                L'assistance par des dons aux populations cibles répond aux besoins immédiats
                et urgents :
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Aide médicale et sanitaire</li>
                <li>Fournitures scolaires pour enfants</li>
                <li>Kits d'hygiène pour femmes</li>
                <li>Assistance d'urgence en cas de crise</li>
              </ul>
            </div>
          </div>

          <div className="text-center">
            <blockquote className="text-xl my-8 max-w-3xl mx-auto">
              "Mais par dessus toute ces choses, revêtez-vous de la charité qui est le lien de la perfection"
              <footer className="mt-2">Colossiens 3:14</footer>
            </blockquote>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-secondary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6 text-white">Soutenez nos actions</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Votre soutien nous permet de continuer et d'étendre nos interventions auprès des femmes et des enfants.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a href="/donate" className="btn-donate">Faire un don</a>
            <a href="/membership" className="bg-white text-secondary px-6 py-2 rounded-md hover:bg-opacity-90 transition-all">Devenir membre</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Domains;
